import Vue from "vue";
import Router from "vue-router";
import loading from "@/components/loading/loading.vue";
import transfer from "@/components/transfer/transfer.vue";
import bindphone from "@/components/bindphone/bindphone.vue";
import index from "@/components/index";
import indexV1 from "@/components/index/index-v1.vue";
import lessonDetail from "@/components/lesson-detail/lesson-detail.vue";
import lesson from "@/components/lesson/lesson.vue";
import lessonDesc from "@/components/lesson-desc/lesson-desc.vue";
import lessonChapter from "@/components/lesson-chapter/lesson-chapter.vue";
import lessonEvaluate from "@/components/lesson-evaluate/lesson-evaluate.vue";
import lessonQuestion from "@/components/lesson-question/lesson-question.vue";
import answer from "@/components/answer/answer.vue";
import lessonNote from "@/components/lesson-note/lesson-note.vue";
import teacher from "@/components/teacher/teacher.vue";
import teacherLesson from "@/components/teacher-lesson/teacher-lesson.vue";
import teacherComment from "@/components/teacher-comment/teacher-comment.vue";
import comment from "@/components/comment/comment.vue";
import ask from "@/components/ask/ask.vue";
import createNote from "@/components/create-note/create-note.vue";
import note from "@/components/note/note.vue";
import me from "@/components/me/me.vue";
import meLesson from "@/components/me-lesson/me-lesson.vue";
import meFav from "@/components/me-fav/me-fav.vue";
import meHistory from "@/components/me-history/me-history.vue";
import meNote from "@/components/me-note/me-note.vue";
import meQuestion from "@/components/me-question/me-question.vue";
import meInfo from "@/components/me-info/me-info.vue";
import other from "@/components/other/other.vue";
import otherHistory from "@/components/other-history/other-history.vue";
import otherLesson from "@/components/other-lesson/other-lesson.vue";
import otherNote from "@/components/other-note/other-note.vue";
import search from "@/components/search/search.vue";
import category from "@/components/category/category.vue";
import lessonList from "@/components/lesson-list/lesson-list.vue";
import topic from "@/components/topic/topic.vue";
import circle from "@/components/circle/circle.vue";
import login from "@/components/login/login.vue";
import middle from "@/components/login/middle.vue";
import register from "@/components/register/register.vue";
import forget from "@/components/forget/forget.vue";
import forgetNext from "@/components/forget-next/forget-next.vue";
import meSetting from "@/components/me-setting/me-setting.vue";
import modifyPassword from "@/components/modify-password/modify-password.vue";
import listtemplate from "@/components/list-template/list-template.vue";
import teacherList from "@/components/teacher-list/teacher.vue";
import hotList from "@/components/hot-list/hot-list.vue"
import updataList from "@/components/updata-list/updata-list.vue"
import error from "@/components/error/error.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/mooc-wx/index",
      meta:{
        sidebar: false
      }
    },
    {
      path: "/mooc-wx/index-v1",
      name: "indexv1",
      meta:{
        sidebar: false
      },
      component: indexV1
    },
    {
      path: "/mooc-wx/listtemplate",
      name: "listtemplate",
      meta: {
        title: "测试",
        background: "#fff"
      },
      component: listtemplate
    },
    {
      path: "/mooc-wx/error",
      name: "error",
      meta: {
        type: "error",
        title: "提示",
        background: "#fff",
        sidebar: false
      },
      component: error
    },
    {
      path: "/mooc-wx/index/:openid",
      name: "loading",
      meta: {
        title: "加载",
        background: "#fff"
      },
      component: loading
    },
    {
      path: "/mooc-wx/transfer/:v_key/:salt/:token/:address",
      name: "transfer",
      meta: {
        title: "加载",
        background: "#fff"
      },
      component: transfer
    },
    {
      path: "/mooc-wx/bindphone",
      name: "bindphone",
      meta: {
        type: "error",
        title: "绑定手机",
        background: "#fff",
        sidebar: false
      },
      component: bindphone
    },
    {
      path: "/mooc-wx/index",
      name: "index",
      meta: {
        title: "首页",
        background: "#fff",
        index: true,
        sidebar: false
      },
      component: index
    },
    {
      path: "/mooc-wx/lesson-detail/:id",
      name: "lesson-detail",
      meta: {
        title: "课程详情"
      },
      component: lessonDetail
    },
    {
      path: "/mooc-wx/lesson",
      name: "lesson",
      meta: {
        title: "开始学习"
      },
      component: lesson,
      children: [
        {
          path: "/mooc-wx/lesson-desc/:courseId/:id",
          meta: {
            title: "课程简介",
            sidebar: false,
            // needLogin:true
            needLogin: false,
            no_href: true
          },
          component: lessonDesc
        },
        {
          path: "/mooc-wx/lesson-chapter/:courseId/:id",
          meta: {
            title: "课程章节",
            sidebar: false,
            // needLogin:true
            needLogin: false,
            no_href: true
          },
          component: lessonChapter
        },
        {
          path: "/mooc-wx/lesson-evaluate/:courseId/:id",
          meta: {
            title: "课程评价",
            sidebar: false,
            // needLogin:true
            needLogin: false,
            no_href: true
          },
          component: lessonEvaluate
        },
        {
          path: "/mooc-wx/lesson-question/:courseId/:id",
          meta: {
            title: "课程问答",
            sidebar: false,
            // needLogin:true
            needLogin: false,
            no_href: true
          },
          component: lessonQuestion
        },
        {
          path: "/mooc-wx/lesson-note/:courseId/:id",
          meta: {
            title: "课程笔记",
            sidebar: false,
            // needLogin:true
            needLogin: false,
            no_href: true
          },
          component: lessonNote
        }
      ]
    },
    {
      path: "/mooc-wx/answer/:id",
      name: "answer",
      meta: {
        title: "看回答"
      },
      component: answer
    },
    {
      path: "/mooc-wx/teacher",
      name: "teacher",
      meta: {
        title: "教师主页"
      },
      component: teacher,
      children: [
        {
          path: "/mooc-wx/teacher-lesson/:id",
          component: teacherLesson,
          meta: {
            title: "教师课程"
          }
        },
        {
          path: "/mooc-wx/teacher-comment/:id",
          component: teacherComment,
          meta: {
            title: "教师评论"
          }
        }
      ]
    },
    {
      path: "/mooc-wx/comment/:courseId/:id",
      name: "comment",
      meta: {
        title: "评论",
        needLogin: true
      },
      component: comment
    },
    {
      path: "/mooc-wx/comment/:courseId",
      name: "commentFromMeLesson",
      meta: {
        title: "评论",
        needLogin: true
      },
      component: comment
    },
    {
      path: "/mooc-wx/ask/:courseId/:id",
      name: "ask",
      meta: {
        title: "提问",
        needLogin: true
      },
      component: ask
    },
    {
      path: "/mooc-wx/create-note/:courseId/:id",
      name: "create-note",
      meta: {
        title: "写笔记",
        needLogin: true
      },
      component: createNote
    },
    {
      path: "/mooc-wx/note/:id",
      name: "note",
      meta: {
        title: "笔记详情"
      },
      component: note
    },
    {
      path: "/mooc-wx/me",
      name: "me",
      meta: {
        background: "#fff",
        title: "我的慕课",
        needLogin: true
      },
      component: me
    },
    {
      path: "/mooc-wx/me-lesson",
      name: "me-lesson",
      meta: {
        title: "我的课程",
        needLogin: true
      },
      component: meLesson
    },
    {
      path: "/mooc-wx/me-fav",
      name: "me-fav",
      meta: {
        title: "我的收藏",
        needLogin: true
      },
      component: meFav
    },
    {
      path: "/mooc-wx/teacherList",
      name: "teacherList",
      meta: {
        title: "名师推荐",
        needLogin: false
      },
      component: teacherList,
    },
    {
      path: "/mooc-wx/me-history",
      name: "me-history",
      meta: {
        title: "最近学习",
        needLogin: true
      },
      component: meHistory,
      needLogin: true
    },
    {
      path: "/mooc-wx/me-note",
      name: "me-note",
      meta: {
        title: "我的笔记",
        needLogin: true
      },
      component: meNote
    },
    {
      path: "/mooc-wx/me-question",
      name: "me-question",
      meta: {
        title: "我的问答",
        needLogin: true
      },
      component: meQuestion
    },
    {
      path: "/mooc-wx/me-info",
      name: "me-info",
      meta: {
        title: "个人信息",
        needLogin: true
      },
      component: meInfo
    },
    {
      path: "/mooc-wx/other",
      name: "other",
      children: [
        {
          path: "/mooc-wx/other/history/:id",
          meta: {
            title: "最近学习"
          },
          component: otherHistory
        },
        {
          path: "/mooc-wx/other/note/:id",
          meta: {
            title: "TA的笔记"
          },
          component: otherNote
        },
        {
          path: "/mooc-wx/other/lesson/:id",
          meta: {
            title: "TA的课程"
          },
          component: otherLesson
        }
      ],
      meta: {
        title: "TA的慕课"
      },
      component: other
    },
    {
      path: "/mooc-wx/search/:keyword",
      name: "search-keyword",
      meta: {
        title: "搜索"
      },
      component: search
    },
    {
      path: "/mooc-wx/search/",
      name: "search",
      meta: {
        title: "搜索"
      },
      component: search
    },
    {
      path: "/mooc-wx/category",
      name: "category",
      meta: {
        title: "课程分类"
      },
      component: category
    },
    {
      path: "/mooc-wx/lesson-list/:type/:type_id",
      name: "lesson-list",
      meta: {
        title: "课程列表"
      },
      component: lessonList
    },
    {
      path: "/mooc-wx/hot-list/:type",
      name: "hot-list",
      meta: {
        title: "热播榜"
      },
      component: hotList
    },
    {
      path: "/mooc-wx/updata-list",
      name: "updata-list",
      meta: {
        title: "最近更新"
      },
      component: updataList
    },
    {
      path: "/mooc-wx/topic/:id",
      name: "topic",
      meta: {
        title: "专题页"
      },
      component: topic
    },
    {
      path: "/mooc-wx/circle/:type",
      name: "circle",
      meta: {
        title: "交流圈",
        needLogin: true
      },
      component: circle
    },
    {
      path: "/mooc-wx/circle/search/:keyword",
      name: "circle-search",
      meta: {
        title: "交流圈",
        needLogin: true
      },
      component: circle
    },
    {
      path: "/mooc-wx/login",
      name: "login",
      meta: {
        title: "登录",
        background: "#fff",
        my: true
      },
      component: login
    },
    {
      path: "/mooc-wx/login/middle",
      name: "middle",
      meta: {
        title: "登录",
        background: "#fff",
        my: true
      },
      component: middle
    },
    {
      path: "/mooc-wx/register",
      name: "register",
      meta: {
        title: "注册",
        background: "#fff",
        my: true
      },
      component: register
    },
    {
      path: "/mooc-wx/forget",
      name: "forget",
      meta: {
        title: "忘记密码",
        background: "#fff",
        my: true
      },
      component: forget
    },
    {
      path: "/mooc-wx/forget-next",
      name: "forget-next",
      meta: {
        title: "忘记密码",
        background: "#fff",
        my: true
      },
      component: forgetNext
    },
    {
      path: "/mooc-wx/me-setting",
      name: "me-setting",
      meta: {
        title: "设置",
        needLogin: true
      },
      component: meSetting
    },
    {
      path: "/mooc-wx/modify-password",
      name: "modify-password",
      meta: {
        title: "修改密码",
        needLogin: true
      },
      component: modifyPassword
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js